import React, { memo, useCallback } from 'react';
import { ViewProps } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import { PromoIconFull } from '@/assets/icons/promoIconFull';
import { BetrAnalytics } from '@/feature/analytics';
import { AnalyticsEvent } from '@/feature/analytics/constants';
import { promosId, useLobbySectionSelection } from '@/feature/lobby/hooks/use-lobby-section-selection';
import { PickemLobbyTabNavigationProp } from '@/navigation/pickem/types';

import { LaunchpadTile } from './LaunchpadTile';

/**
 * A tile component that provides navigation to the main promos screen
 * @param onLayout - Layout event handler for the tile - function from the parent LeftSideTabBar
 * @param updateTab - Callback function to update the currently active tab in parent navigation
 */
export const PickemLobbyPromosTile = memo(
    ({ onLayout }: { onLayout: ViewProps['onLayout']; updateTab: () => void }) => {
        const selectedTile = useLobbySectionSelection(state => state.selectedTile);
        const navigation = useNavigation<PickemLobbyTabNavigationProp>();

        const isSelected = selectedTile === promosId;

        const onPressLobby = useCallback(() => {
            BetrAnalytics.trackProductEvent(AnalyticsEvent.VIEW_ALL_PROMOS_FROM_LOBBY_TILE);
            navigation.navigate('LobbyPromohub');
        }, [navigation]);

        return (
            <LaunchpadTile
                onLayout={onLayout}
                testID={'pickem-lobby-promos-tile'}
                icon={<PromoIconFull />}
                label={'Promos'}
                onPress={onPressLobby}
                selected={isSelected}
                paddingTop={'s14'}
            />
        );
    }
);

PickemLobbyPromosTile.displayName = 'PickemLobbyPromosTile';
